import React from "react";
import ModuleLogo from "./left-topbar/ModuleLogo";
import Actions from "./left-topbar/Actions";
import {HeaderMenuWrapper} from "../header/header-menu/HeaderMenuWrapper";

const LeftTopbar = () => {
    return (
        <>
            <div className={`d-flex`}>
                <Actions>
                    <ModuleLogo/>
                </Actions>

                <HeaderMenuWrapper/>
            </div>
        </>
    );
}

export default LeftTopbar;
